/**
 * Created by admin on 2018/6/12.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import { Badge, Button, Icon, Input, message, Modal, Radio, Select, Table, Tabs, TimePicker, Upload } from 'antd';
import './BoardManage.less';
import { Btn, OperateSpan } from '../../components/Widgets';
import IconTip from '../../components/IconTip';
import { CLIENT_ID, COMMA } from '../../utils/constants';
import moment from 'moment';

const RadioGroup = Radio.Group;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

const BORDER_TAB = '1';
const ENERGY_TAB = '2';
const VERSION_TAB = '3';

const format = 'HH:mm';
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
let i18n;

class BoardManage extends PureComponent {
  constructor() {
    super();
    this.state = {
      activeKey: BORDER_TAB,
      logoFileList: [],
      logoENFileList: [],
      bgFileList: [],
      isDef: false,
      showEdit: false,
      showVersionEdit: false,
      versionName: '',
      version: '',
      downloadUrl: '',
      descriveInfo: '',
      apkFileList: []
    };
  }

  render() {
    const { dispatch, intl, rooms, tempSettings } = this.props;
    const {
      activeKey,
      tempName,
      roomIds,
      logoFileList,
      logoENFileList,
      bgFileList,
      showEdit,
      showVersionEdit,
      versionName,
      version,
      downloadUrl,
      descriveInfo
    } = this.state;
    i18n = this.props.i18n;

    const defState = {
      tempId: 0,
      tempName: '',
      tempLogo: '',
      logoFileList: [],
      tempLogoEN: '',
      logoENFileList: [],
      tempBg: '',
      bgFileList: [],
      roomIds: [],
      isDef: false
    };

    const uploadProps = {
      name: 'fileUpload',
      action: `/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
        'token'
      )}&fromType=${CLIENT_ID}`,
      headers: { token: sessionStorage.getItem('token') },
      accept: 'image/*',
      listType: 'picture-card',
      multiple: false,
      style: { width: '100%' }
    };

    const check = (file, size, flag) => {
      if (!/\.(JPG|JPEG|PNG)$/.test(file.name.toLocaleUpperCase())) {
        flag &&
        message.error(
          intl.formatMessage({ id: 'board_manage_error_image_format' })
        );
        return false;
      }
      if (file.size / 1024 > size) {
        flag &&
        message.error(intl.formatMessage({ id: 'board_manage_big_image' }));
        return false;
      }
      return true;
    };

    const uploadChange = (info, flag) => {
      let { fileList, file } = info;
      if (file.name.indexOf('&') > -1) {
        file.name = file.name.replace(/&/g, '$');
      }
      let fileUrl = '';
      if (file.status === 'done') {
        if (file.response && file.response.result === 0) {
          fileUrl = file.response.list[0].fileUrl;
          fileList = [file];
        }
      } else if (file.status === 'error') {
        fileUrl = '';
        fileList = [];
        Modal.error({
          title: 'ERROR',
          content: intl.formatMessage({ id: 'image_upload_error' }),
          okText: intl.formatMessage({ id: 'modal_manage_btn_ok' })
        });
      } else if (file.status === 'removed') {
        fileUrl = '';
        fileList = [];
      }
      switch (flag) {
        case 'logo':
          this.setState({
            tempLogo: fileUrl,
            logoFileList: check(file, 500) ? fileList : []
          });
          break;
        case 'logoEN':
          this.setState({
            tempLogoEN: fileUrl,
            logoENFileList: check(file, 500) ? fileList : []
          });
          break;
        case 'bg':
          this.setState({
            tempBg: fileUrl,
            bgFileList: check(file, 1024 * 2) ? fileList : []
          });
          break;
      }
    };

    const uploadLogo = {
      ...uploadProps,
      fileList: logoFileList,
      onChange: info => {
        uploadChange(info, 'logo');
      },
      beforeUpload: file => {
        return check(file, 500, true);
      }
    };
    const uploadLogoEN = {
      ...uploadProps,
      fileList: logoENFileList,
      onChange: info => {
        uploadChange(info, 'logoEN');
      },
      beforeUpload: file => {
        return check(file, 500, true);
      }
    };
    const uploadBg = {
      ...uploadProps,
      fileList: bgFileList,
      onChange: info => {
        uploadChange(info, 'bg');
      },
      beforeUpload: file => {
        return check(file, 1024 * 2, true);
      }
    };

    const uploadButton = (
      <div className="upload-btn">
        <Icon type="plus" />
      </div>
    );

    const deleteTemp = ({ tempId, tempName }) => {
      dispatch({ type: 'account/dropTempSettings', tempId, tempName });
    };


    const toggleEdit = rec => {
      if (showEdit) {
        this.setState({ ...defState, showEdit: false });
      } else if (rec) {
        this.setState({
          tempId: rec.tempId,
          tempName: rec.tempName,
          tempLogo: rec.tempLogo,
          logoFileList: [
            {
              uid: -Math.random(),
              name: `tmp_img_${rec.tempId}_logo`,
              status: 'done',
              url: rec.tempLogo,
              thumbUrl: rec.tempLogo
            }
          ],
          tempLogoEN: rec.tempLogoEN,
          logoENFileList: [
            {
              uid: -Math.random(),
              name: `tmp_img_${rec.tempId}_logoEN`,
              status: 'done',
              url: rec.tempLogoEN,
              thumbUrl: rec.tempLogoEN
            }
          ],
          tempBg: rec.tempBg,
          bgFileList: [
            {
              uid: -Math.random(),
              name: `tmp_img_${rec.tempId}_bg`,
              status: 'done',
              url: rec.tempBg,
              thumbUrl: rec.tempBg
            }
          ],
          roomIds: rec.roomIds,
          isDef: rec.isDef,
          showEdit: true
        });
      } else {
        this.setState({ ...defState, showEdit: true });
      }
    };

    const save = () => {
      const { tempName, tempLogo, tempLogoEN, tempBg } = this.state;
      if (!tempName || tempName === '') {
        Modal.error({
          content: intl.formatMessage({ id: 'modal_manage_no_template_name' })
        });
        return;
      } else if (!tempLogo || tempLogo === '') {
        Modal.error({
          content: intl.formatMessage({ id: 'modal_manage_no_logo' })
        });
        return;
      } else if (!tempLogoEN || tempLogoEN === '') {
        Modal.error({
          content: intl.formatMessage({ id: 'modal_manage_no_eng_logo' })
        });
        return;
      } else if (!tempBg || tempBg === '') {
        Modal.error({
          content: intl.formatMessage({ id: 'modal_manage_no_bg' })
        });
        return;
      }
      dispatch({
        type: 'account/saveTempSetting',
        payload: { ...this.state, roomIds: this.state.roomIds.join(COMMA) }
      });
      toggleEdit();
    };

    const columns = [
      {
        title: intl.formatMessage({ id: 'modal_manage_name' }),
        dataIndex: 'tempName',
        width: '15%',
        key: 'name'
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_bind_meeting_name' }),
        dataIndex: 'rooms',
        key: 'rooms'
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_operate' }),
        width: '10%',
        key: 'opt',
        render: (text, record) => (
          <div>
            {record.isDef ? null : (
              <span className="table-opt">
                <OperateSpan onClick={() => toggleEdit(record)}>
                  <IconTip
                    title={intl.formatMessage({ id: 'modal_manage_edit' })}
                    type="75bianji"
                  />
                </OperateSpan>
                {!record.isDef && (
                  <OperateSpan
                    onClick={() => {
                      if (record.rooms !== '') {
                        Modal.confirm({
                          content: intl.formatMessage({
                            id: 'modal_manage_meeting_room_Occupy'
                          }),
                          iconType: 'info-circle',
                          okText: intl.formatMessage({
                            id: 'modal_manage_btn_ok'
                          }),
                          okType: 'primary',
                          cancelText: intl.formatMessage({
                            id: 'modal_manage_btn_cancel'
                          }),
                          onOk: () => {
                            deleteTemp(record);
                          }
                        });
                      } else {
                        deleteTemp(record);
                      }
                    }}
                  >
                    <IconTip
                      title={intl.formatMessage({ id: 'modal_manage_delete' })}
                      type="shanchu"
                    />
                  </OperateSpan>
                )}
              </span>
            )}
          </div>
        )
      }
    ];

    const data =
      tempSettings &&
      tempSettings.list.map(t => {
        const temp = { ...t };
        temp.isDef = t.isDef === 1;
        const ids = [];
        let names = [], namesEn = [];
        rooms &&
        rooms.map(r => {
          if( intl.locale === 'en_US'){
            if (r.tempId === t.tempId) {
              ids.push(String(r.id));
              namesEn.push(r.nameEn);
            }
          } else {
            if (r.tempId === t.tempId) {
              ids.push(String(r.id));
              names.push(r.name);
            }
          }
        });
        temp['roomIds'] = ids;
        if( intl.locale === 'en_US') {
          temp['rooms'] = namesEn.join(', ');
        } else {
          temp['rooms'] = names.join(', ');
        }
        return temp;
      });

    const pagination = {
      total: tempSettings ? tempSettings.total : 0,
      onChange: page => {
        dispatch({ type: 'account/getTempSettings', page });
      },
      pageSize: 10,
      current: tempSettings ? tempSettings.pageNo : 1
    };

    const toggleVersionEdit = ()=>{
      // 关闭时清除数据
      if(showVersionEdit) {
        this.setState({
          versionName: '',
          version: '',
          apkFileList: [],
          downloadUrl: '',
          descriveInfo: '',
          showVersionEdit: !showVersionEdit
        });
        return;
      }
      this.setState({showVersionEdit: !showVersionEdit});
    };
    const { locale } = i18n;
    const versionApkUploadProps = {
      name: 'fileUpload',
      action: `/storage/file/savefile?lang=${locale}&token=${sessionStorage.getItem(
        'token'
      )}&fromType=${CLIENT_ID}`,
      headers: { token: sessionStorage.getItem('token') },
      fileList: this.state.apkFileList,
      accept: '.apk',
      listType: 'text',
      multiple: false,
      style: { width: '100%' },
      onChange: info => {
        onChangeApk(info.file, info.fileList);
      },
      beforeUpload: file => {
        if(downloadUrl != '') {
          message.warn(intl.formatMessage({ id: 'board_manage_has_apk' }));
          return false;
        }
        if (!/\.APK$/.test(file.name.toLocaleUpperCase())) {
          message.warn(intl.formatMessage({ id: 'board_manage_error_apk_format' }));
          return false;
        }
        if (file.size / 1024 > 100 * 1024) {
          message.warn(intl.formatMessage({ id: 'board_manage_big_apk' }));
          return false;
        }
        return true;
      }
    };

    const onChangeApk = (file, fileList) => {
      if (file.name.indexOf('&') > -1) {
        file.name = file.name.replace(/&/g, '$');
      }
      let fileUrl = '';
      if (file.status === 'done') {
        if (file.response && file.response.result === 0) {
          fileUrl = file.response.list[0].fileUrl;
          const fileName = file.name.substr(0, file.name.lastIndexOf('.'));
          this.setState({versionName: fileName})
        } else {
          fileList = [];
          Modal.error({
            title: 'ERROR',
            content: file.response.msg,
            okText: intl.formatMessage({ id: 'modal_manage_btn_ok' })
          });
        }
      } else if (file.status === 'error') {
        fileUrl = '';
        fileList = [];
        Modal.error({
          title: 'ERROR',
          content: intl.formatMessage({ id: 'image_upload_error' }),
          okText: intl.formatMessage({ id: 'modal_manage_btn_ok' })
        });
      } else if (file.status === 'removed') {
        fileUrl = '';
        fileList = [];
      }
      this.setState({downloadUrl: fileUrl})
      this.setState({apkFileList: [...fileList]});
    }
    // 提交
    const saveVersion = () => {
      // 检测必填字段
      const { versionName, downloadUrl, descriveInfo, version } = this.state;
      if(version == '' || downloadUrl == '' || versionName == '') {
        message.warn(intl.formatMessage({id: 'upload_info_prompt'}));
        return;
      }
      const promise = new Promise((resolve, reject) => {
        dispatch({
          type: 'account/saveBoardVersion',
          resolve,
          reject,
          versionInfo: {
            name: versionName,
            downloadUrl: downloadUrl,
            describeInfo: descriveInfo,
            version: version
          }
        });
      });
      promise.then(
        () => {
          toggleVersionEdit();
        },
        msg => {
          Modal.warn({ content: msg });
        }
      );
    };
    return (
      <div className="board-management">
        <Tabs
          type="card"
          activeKey={activeKey}
          onChange={activeKey => this.setState({ activeKey: activeKey })}
        >
          <TabPane key={BORDER_TAB} tab={i18n.messages.boardman_1_0}>
            <div className="new-btn">
              <Button type="primary" icon="plus" onClick={() => toggleEdit()}>
                {intl.formatMessage({ id: 'modal_manage_add' })}
              </Button>
            </div>
            <div className="temp-list">
              <Table
                rowKey={record => record.tempId}
                columns={columns}
                dataSource={data}
                pagination={pagination}
              />
            </div>
            <Modal
              wrapClassName="board-mange-wrapper modal-close-header"
              visible={showEdit}
              title={intl.formatMessage({ id: 'modal_manage_edit_title' })}
              onCancel={() => toggleEdit()}
              footer={
                <div className="service-manage-footer">
                  <Btn onClick={() => toggleEdit()}>
                    {intl.formatMessage({ id: 'modal_manage_btn_cancel' })}
                  </Btn>
                  <Btn primary onClick={() => save()}>
                    {intl.formatMessage({ id: 'modal_manage_btn_ok' })}
                  </Btn>
                </div>
              }
            >
              <div className="temp-setting">
                <div className="setting-row">
                  <span className="setting-label">
                    <i>*</i>
                    {intl.formatMessage({
                      id: 'modal_manage_edit_template_name'
                    })}
                  </span>
                  <span className="setting-value">
                    <Input
                      value={tempName || ''}
                      disabled={this.state.isDef}
                      placeholder={intl.formatMessage({
                        id: 'modal_manage_edit_template_name_placeholder'
                      })}
                      onChange={e => {
                        this.setState({ tempName: e.target.value });
                      }}
                    />
                  </span>
                </div>
                <div className="setting-row">
                  <span className="setting-label">
                    <i>*</i>
                    {intl.formatMessage({ id: 'modal_manage_edit_uploadlogo' })}
                  </span>
                  <span className="setting-value">
                    <Upload {...uploadLogo}>
                      {logoFileList.length === 0 && uploadButton}
                    </Upload>
                  </span>
                </div>
                <div className="hint-text">
                  {intl.formatMessage({
                    id: 'modal_manage_edit_uploadlogo_hint'
                  })}
                </div>
                <div className="setting-row">
                  <span className="setting-label">
                    <i>*</i>
                    {intl.formatMessage({
                      id: 'modal_manage_edit_eng_uploadlogo'
                    })}
                  </span>
                  <span className="setting-value">
                    <Upload {...uploadLogoEN}>
                      {logoENFileList.length === 0 && uploadButton}
                    </Upload>
                  </span>
                </div>
                <div className="hint-text">
                  {intl.formatMessage({
                    id: 'modal_manage_edit_eng_uploadlogo_hint'
                  })}
                </div>
                <div className="setting-row">
                  <span className="setting-label">
                    <i>*</i>
                    {intl.formatMessage({ id: 'modal_manage_edit_bg' })}
                  </span>
                  <span className="setting-value">
                    <Upload {...uploadBg}>
                      {bgFileList.length === 0 && uploadButton}
                    </Upload>
                  </span>
                </div>
                <div className="hint-text">
                  {intl.formatMessage({ id: 'modal_manage_edit_bg_hint' })}
                </div>
                <div className="setting-row">
                  <span className="setting-label">
                    {intl.formatMessage({ id: 'modal_manage_meeting_room' })}
                  </span>
                  <span className="setting-value">
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      value={roomIds}
                      disabled={this.state.isDef}
                      optionFilterProp={'children'}
                      dropdownClassName={'board-manage-drop-down'}
                      onChange={value => {
                        this.setState({ roomIds: value });
                      }}
                    >
                      {rooms &&
                      rooms.map(r => <Option key={r.id}>{r.name}</Option>)}
                    </Select>
                  </span>
                </div>
              </div>
            </Modal>
          </TabPane>
          <TabPane key={ENERGY_TAB} tab={i18n.messages.boardman_2_0}>
            {this.getEnergyTal()}
          </TabPane>
          <TabPane key={VERSION_TAB} tab={i18n.messages.boardman_3_0}>
            <div>
              <div className="new-btn">
                <Button type="primary" icon="plus" onClick={() => toggleVersionEdit()}>
                  {intl.formatMessage({ id: 're_upload' })}
                </Button>
              </div>
              {this.getVersionTal()}
              <Modal
                wrapClassName="board-mange-wrapper modal-close-header"
                visible={showVersionEdit}
                maskClosable={false}
                mask={true}
                width="50%"
                title={intl.formatMessage({id: 'modal_manage_version_title'})}
                onCancel={() => toggleVersionEdit()}
                footer={
                  <div className="service-manage-footer">
                    <Btn onClick={() => toggleVersionEdit()}>
                      {intl.formatMessage({ id: 'modal_manage_btn_cancel' })}
                    </Btn>
                    <Btn primary onClick={() => saveVersion()}>
                      {intl.formatMessage({ id: 'modal_manage_btn_ok' })}
                    </Btn>
                  </div>
                }>
                <div className="temp-setting">
                  <div className="setting-row">
                    <span className="setting-label">
                    <i>*</i>
                      {intl.formatMessage({
                        id: 'modal_manage_version_file'
                      })}
                    </span>
                    <span className="setting-value">
                      <Upload {...versionApkUploadProps}>
                      {downloadUrl === '' &&
                      <Button>
                        <Icon type="upload"/>{intl.formatMessage({id: 're_upload'})}
                      </Button>
                      }
                    </Upload>
                    </span>
                  </div>
                </div>
                <div className="temp-setting">
                  <div className="setting-row">
                    <span className="setting-label">
                    <i>*</i>
                      {intl.formatMessage({
                        id: 'modal_manage_version_name'
                      })}
                    </span>
                    <span className="setting-value">
                      <Input
                        value={versionName || ''}
                        disabled={false}
                        unselectable="on"
                        placeholder={intl.formatMessage({
                          id: 'modal_manage_version_name_placeholder'
                        })}
                      />
                    </span>
                  </div>
                </div>
                <div className="temp-setting">
                  <div className="setting-row">
                    <span className="setting-label">
                    <i>*</i>
                      {intl.formatMessage({
                        id: 'modal_manage_version'
                      })}
                    </span>
                    <span className="setting-value">
                      <Input
                        value={version || ''}
                        placeholder={intl.formatMessage({
                          id: 'modal_manage_version_placeholder'
                        })}
                        onChange={e => {
                          this.setState({ version: e.target.value })
                        }}
                      />
                    </span>
                  </div>
                </div>
                <div className="temp-setting">
                  <div className="setting-row">
                    <span className="setting-label">
                      {intl.formatMessage({
                        id: 'modal_manage_version_desc'
                      })}
                    </span>
                    <span className="setting-value">
                      <Input.TextArea
                        value={descriveInfo || ''}
                        autosize={{minRows: 2, maxRows: 6}}
                        placeholder={intl.formatMessage({
                          id: 'modal_manage_version_desc_placeholder'
                        })}
                        onChange={e => {
                          this.setState({ descriveInfo: e.target.value })
                        }}
                      />
                    </span>
                  </div>
                </div>
              </Modal>
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }

  getEnergyTal = () => {
    const { displayboardEnergy, dispatch } = this.props;
    let energyTimePickerDisabled = false;
    if (displayboardEnergy && displayboardEnergy.mode == 0) {
      energyTimePickerDisabled = true;
    }
    return (
      <div className="temp-setting">
        <div className="setting-row">
          <span className="setting-label1">{i18n.messages.boardman_2_1}</span>
          <span className="setting-value1">
            <RadioGroup
              value={displayboardEnergy.mode}
              className="radiogroup"
              name="radiogroup"
              onChange={({ target }) => {
                displayboardEnergy.mode = target.value;
                dispatch({
                  type: 'account/update',
                  payload: displayboardEnergy
                });
              }}
            >
              <Radio className="radio" value={0}>
                {i18n.messages.boardman_2_2}
              </Radio>
              <Radio className="radio" value={1}>
                {i18n.messages.boardman_2_3}
              </Radio>
              <Radio className="radio" value={2}>
                {i18n.messages.boardman_2_4}
              </Radio>
            </RadioGroup>
          </span>
        </div>
        <div className="setting-row">
          <span className="setting-label1">{i18n.messages.boardman_2_5}</span>
          <span className="setting-value1">
            <TimePicker
              format={format}
              disabled={energyTimePickerDisabled}
              value={moment(displayboardEnergy.powerOn, format)}
              onChange={(time, timeString) => {
                displayboardEnergy.powerOn = timeString;
                dispatch({
                  type: 'account/update',
                  payload: displayboardEnergy
                });
              }}
            />
          </span>
        </div>
        <div className="setting-row">
          <span className="setting-label1">{i18n.messages.boardman_2_6}</span>
          <span className="setting-value1">
            <TimePicker
              format={format}
              disabled={energyTimePickerDisabled}
              value={moment(displayboardEnergy.powerOff, format)}
              onChange={(time, timeString) => {
                displayboardEnergy.powerOff = timeString;
                dispatch({
                  type: 'account/update',
                  payload: displayboardEnergy
                });
              }}
            />
          </span>
        </div>
        <div className="setting-row">
          <span className="setting-label1" />
          <span className="setting-value1">
            <Button
              type="primary"
              onClick={() => {
                if (
                  this.checkOnOffTime(
                    displayboardEnergy.powerOn,
                    displayboardEnergy.powerOff
                  )
                ) {
                  dispatch({
                    type: 'account/setDisplayboardEnergy'
                  });
                } else {
                  Modal.error({
                    content: i18n.messages.boardman_2_7
                  });
                }
              }}
            >
              {i18n.messages.boardman_2_8}
            </Button>
          </span>
        </div>
      </div>
    );
  };
  // 版本更新
  getVersionTal = () => {
    const { dispatch, intl ,boardVersionList } = this.props;
    const applyVersion = (id) => {
      const promise = new Promise((resolve, reject) => {
        dispatch({
          type: 'account/applyBoardVersion',
          resolve,
          reject,
          id: id
        });
      });
      promise.then(()=> {

      }, msg => {
        Modal.warn({content: msg});
      });
    };
    const columns = [
      {
        title: intl.formatMessage({ id: 'modal_manage_version_name' }),
        dataIndex: 'name',
        width: '10%',
        key: 'name'
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_version' }),
        dataIndex: 'version',
        width: '10%',
        key: 'version'
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_version_create_user' }),
        dataIndex: 'createUserName',
        width: '10%',
        key: 'createUserName'
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_version_create_time' }),
        dataIndex: 'createTime',
        width: '15%',
        key: 'createTime',
        render: time => {return (<span>{ moment(time).format(dateTimeFormat) }</span>)}
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_version_url' }),
        dataIndex: 'downloadUrl',
        width: '20%',
        key: 'downloadUrl',
        render: text => <a>{text}</a>
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_version_desc' }),
        dataIndex: 'describeInfo',
        width: '20%',
        key: 'describeInfo'
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_version_status' }),
        dataIndex: 'status',
        width: '10%',
        key: 'status',
        render: status => {
          if(status === 0) return(<Badge status="success" text={intl.formatMessage({id: 'system_manage_board_useing'})}/>)
          if(status === 1) return(<Badge status="default" text={intl.formatMessage({id: 'system_manage_board_stop'})}/>)
          if(status === 2) return(<Badge status="error" text={intl.formatMessage({id: 'system_manage_board_error'})}/>)
        }
      },
      {
        title: intl.formatMessage({ id: 'modal_manage_operate' }),
        width: '5%',
        key: 'opt',
        render: (text, record) => (
          <div>
            <span className="table-opt">
              {record.status === 0 &&
                <OperateSpan>
                  <IconTip
                    title={intl.formatMessage({ id: 'system_manage_board_useing' })}
                    type="tianchongxing-"
                    disabled={true}
                  />
                </OperateSpan>
                }
              {record.status === 2 &&
              <OperateSpan>
                <IconTip
                  title={intl.formatMessage({ id: 'system_manage_board_error' })}
                  type="tianchongxing-"
                  disabled={true}
                />
              </OperateSpan>
              }
              {record.status === 1 && (
                <OperateSpan
                  onClick={() => {
                    if (record.rooms !== '') {
                      Modal.confirm({
                        content: intl.formatMessage({
                          id: 'modal_manage_board_version_occupy'
                        }),
                        iconType: 'info-circle',
                        okText: intl.formatMessage({
                          id: 'modal_manage_btn_ok'
                        }),
                        okType: 'primary',
                        cancelText: intl.formatMessage({
                          id: 'modal_manage_btn_cancel'
                        }),
                        onOk: () => {
                          applyVersion(record.id);
                        }
                      });
                    } else {
                      applyVersion(record.id);
                    }
                  }}
                >
                  <IconTip
                    title={intl.formatMessage({ id: 'system_manage_board_start' })}
                    type="weibiaoti--"
                  />
                </OperateSpan>
              )}
              </span>
          </div>
        )
      }
    ];
    return (
      <div className="temp-list">
        <Table
          rowKey={record => record.id}
          columns={columns}
          dataSource={boardVersionList}
        />
      </div>
    )
  };
  checkOnOffTime = (on, off) => {
    on = on.split(':');
    off = off.split(':');
    let onH = Number(on[0]),
      onm = Number(on[1]),
      offH = Number(off[0]),
      offm = Number(off[1]);
    if (offH < onH) {
      return false;
    }
    if (offH == onH && offm <= onm) {
      return false;
    }
    return true;
  };
}

const mapStateToProps = state => {
  const { account, i18n } = state;
  account.i18n = i18n;
  return { ...account };
};

export default connect(mapStateToProps)(injectIntl(BoardManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/BoardManage.js